import { all, call, delay, race, take } from 'redux-saga/effects';

import { refreshAuthToken } from '@payaca/store/auth/refreshAuthToken';
import * as api from '../services/api';
import { ActionType } from './jobsTypes';

export const actions = {
  acceptQuote: (jobId, callback) => ({
    type: ActionType.ACCEPT_QUOTE,
    jobId,
    callback,
  }),
  declineJob: (jobId, callback) => ({
    type: ActionType.DECLINE_JOB,
    jobId,
    callback,
  }),
  duplicateJob: (jobId, customerId, callback) => ({
    type: ActionType.DUPLICATE_JOB,
    jobId,
    customerId,
    callback,
  }),
};

const watchAcceptJob = function* watchAcceptJob() {
  while (true) {
    const { jobId, callback } = yield take(ActionType.ACCEPT_QUOTE);
    yield call(refreshAuthToken);
    try {
      const { response, timeout } = yield race({
        response: call(api.acceptQuote, jobId),
        timeout: delay(15000),
      });
      if (timeout) {
        throw new api.TimeoutException('Accept job request timed out.');
      }

      if (callback) {
        callback(null, response);
      }
    } catch (e) {
      console.log(e);
      if (callback) {
        callback(e);
      }
    }
  }
};

const watchDeclineJob = function* watchDeclineJob() {
  while (true) {
    const { jobId, callback } = yield take(ActionType.DECLINE_JOB);
    yield call(refreshAuthToken);
    try {
      const { response, timeout } = yield race({
        response: call(api.declineJob, jobId),
        timeout: delay(15000),
      });
      if (timeout) {
        throw new api.TimeoutException('Decline job request timed out.');
      }

      if (callback) {
        callback(null, response);
      }
    } catch (e) {
      console.log(e);
      if (callback) {
        callback(e);
      }
    }
  }
};

const watchDuplicateJob = function* watchDuplicateJob() {
  while (true) {
    const { jobId, customerId, callback } = yield take(
      ActionType.DUPLICATE_JOB
    );
    yield call(refreshAuthToken);
    try {
      console.log('Duplicating the job');
      const { response, timeout } = yield race({
        response: call(api.duplicateJob, jobId, customerId),
        timeout: delay(15000),
      });
      if (timeout) {
        throw new api.TimeoutException('Duplicate job request timed out.');
      }

      if (callback) {
        callback(null, response);
      }
    } catch (e) {
      console.log(e);
      if (callback) {
        callback(e);
      }
    }
  }
};

export const saga = function* saga() {
  yield all([watchAcceptJob(), watchDeclineJob(), watchDuplicateJob()]);
};
